// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"0": "moment","3": "charts","4": "movements","5": "transactions",}[chunkId] || chunkId) + "." + {"0": "8c4ff82b28dbde57","1": "543dedf3b33325d3","2": "70f97df29da99ac5","3": "689ad57ff9d3010b","4": "afadc2ae976d090d","5": "4e99b9121d22cddf",}[chunkId] + ".chunk.js"
}